<template>
  <FooterPageLayout v-model:selectedListItemIndexFromProps="selectedListItemIndex" :pageData="privacyPageData">
    <div class="terms-content wd-my-6 <xs:wd-mx-5 <xs:wd-mb-9" v-html="$t('privacy_policy_content')" />
  </FooterPageLayout>
</template>

<script lang="ts" setup>
import FooterPageLayout from '@/components/FooterPageLayout.vue'

defineOptions({
  name: 'TermsPrivacyPage',
})

const nuxtApp = useNuxtApp()
const { $i18n } = nuxtApp
const route = useRoute()

const selectedListItemIndex = ref(0)

const privacyPageData = computed(() => ({
  title: $i18n.t('footer_private_policy'),
  list: [
    {
      text: $i18n.t('footer_user_policy'),
      localePath: nuxtApp.$localePath({
        name: 'terms-consumer',
        query: route.query,
      }),
    },
    {
      text: $i18n.t('footer_private_policy'),
      localePath: nuxtApp.$localePath({
        name: 'terms-privacy',
        query: route.query,
      }),
    },
    {
      text: $i18n.t('footer_refund_policy'),
      localePath: nuxtApp.$localePath({
        name: 'terms-refund',
        query: route.query,
      }),
    },
    ...($i18n.locale.value === 'ja'
      ? [
          {
            text: $i18n.t('footer_japan_term'),
            localePath: nuxtApp.$localePath({
              name: 'terms-law',
              query: route.query,
            }),
          },
        ]
      : []),
  ],
}))

onMounted(() => {
  const defaultSelectedIndex = privacyPageData.value.list.findIndex(item => item.localePath.includes('/terms/privacy'))
  selectedListItemIndex.value = defaultSelectedIndex
})
</script>

<style lang="scss" scoped>
@use '@/assets/sass/modules/_terms-content.scss' as *;

.terms-content {
  @include terms-content-reset;
}
</style>
